import React from 'react'
import './style.css'

export default () =>(
    <div className='_404_container'>
        <span className='mensagem'>Nada aqui ainda :/<br/><br/><small>Tente os outros links por enquanto ;)</small> </span>
    </div>
)


// WEBPACK FOOTER //
// ./src/views/administrativo/404/index.js